import React , { useEffect, useState } from 'react'; 
import storage from '../factory/StorageFactory.js';
// import '../styles/card-style.css'
import FormContainer from '../components/FormContainer.jsx';
import config from '../appconfig/config.json';


const PreKnockoutFailed = (props) => {

    const [display,setDisplay] = useState({title:'', errMsg:'', btnType:'',code:''})

    const btnType = {
        GetInTouch:'GetInTouch',
        ResumeApp:'ResumeApp',
        BacktoHome:'BacktoHome'
    }

    const Error= {
        Code_M11:'M11', // turnover > 20Mil
        Code_M12:'M12', // PreKO Fail
        Code_M13:'M13', // STP - re-application within 6 months
        Code_M14:'M14', // no more
        Code_M15:'M15', // CIF Tagging
        Code_M16:'M16', // Industries not qualified
        Code_M17:'M17', // Corportate SH
        Code_M18:'M18', // PDA bank lvl
        Code_500:'500', // default
        Code_M08:'M08', // SSIC code blacklist
        Code_M09:'M09', // Min turnover < 100K
        Code_M21:'M21', // Submission failed to WAA
        Code_M22:'M22', // Min turnover < 700K (if hybrid only Trade)
        Code_M23:'M23', // Min turnover < 300K (if hybrid not standalone trade nor property)
        Code_M26:'M26', // Previously Unmat,
        Code_M29:'M29'  // Invalid Entity Status
    }

    useEffect(() => {

        window.scrollTo(0,0);
        storage.clearAll();
        displayMsg();
     }, []);

     const handleBacktohomeClick = () => {
        window.location.href = config.link.BacktoHome;
    }

    const handleCancelClick = ()=> {
        window.location.href = config.link.Cancle;
    }

    const handleGetInTouchClick = () =>{
        window.location.href = config.link.GetInTouch;
    }

    const displayMsg = () => {
        let invalid = {
            title:'',
            errMsg:'',
            btnType:'',
            code:''
        }

        if(props.location.state !== undefined) {

            let errType = props.location.state.errType;
            if(errType === Error.Code_M08) {
                invalid.title = 'Thank you for your interest.';
                invalid.errMsg = 'We are unable to process your request. The financing requirement is not met.\n<Code '+errType+'>';
                invalid.btnType = btnType.BacktoHome;
                invalid.code = errType;
            }
            else if(errType === Error.Code_M09) {
                invalid.title = 'Thank you for your interest.';
                invalid.errMsg = 'Your application is unsuccessful.\nTo apply online, a minimum of S$100,000 turnover is required. <Code '+errType+'>';
                invalid.btnType = btnType.BacktoHome;
                invalid.code = errType;
            }
            if(errType === Error.Code_M11) {// only for BTL/ no hybrid and AIP
                invalid.title = 'Oops!';
                invalid.errMsg = 'Your application is unsuccessful. Your business turnover has exceeded the maximum eligibility of S$20Mil. <Code '+errType+'>\nGet in touch with us for assistance.';
                invalid.btnType = btnType.GetInTouch;
                invalid.code = errType;
            }
            else if(errType === Error.Code_M12) {
                // console.log('Code_M12');
                invalid.title = 'Oops!';
                invalid.errMsg = 'Your submission is unsuccessful.\nTechnical issue.<Code '+errType+'>\n\nPlease reapply.';
                invalid.btnType = btnType.BacktoHome;
                invalid.code = errType;
            }
            else if(errType === Error.Code_M13) { //Only BTL, blaze red (DF_PREQUAL_001_1)
                // console.log('Code_M13');
                invalid.title = 'Oops!';
                invalid.errMsg = 'Your application is unsuccessful.<Code '+errType+'>\nYou may reapply twelve months after your last application.';
                invalid.btnType = btnType.BacktoHome;
                invalid.code = errType;
            }
            else if(errType === Error.Code_M14) { //no more
                // console.log('Code_M14')
                invalid.title = 'Oops!';
                invalid.errMsg = 'Your submission is unsuccessful. You have a pending application in our records.<Code '+errType+'>';
                invalid.btnType = btnType.BacktoHome;
                invalid.code = errType;
            }
            else if(errType === Error.Code_M15) { // blaze red
                // console.log('Code_M15')
                invalid.title = 'Thank you for your interest.';
                invalid.errMsg = 'Your application is unsuccessful.<Code '+errType+'>';
                invalid.btnType = btnType.BacktoHome;
                invalid.code = errType;
            }
            else if(errType === Error.Code_M16) { //only BTL, blaze red
                // console.log('Code_M16')
                invalid.title = 'Oops!';
                invalid.errMsg = 'We are unable to process your application online.\nOur Relationship Manager will be in touch with you.<Code '+errType+'>';
                invalid.btnType = btnType.BacktoHome;
                invalid.code = errType;
            }
            else if(errType === Error.Code_M18) { //only BTL, blze red
                console.log('Code_M18')
                invalid.title = 'Oops!';
                invalid.errMsg = 'Your online request is unsuccessful.<Code '+errType+'>';
                invalid.btnType = btnType.BacktoHome;
                invalid.code = errType;
            }
            else if(errType === Error.Code_500){
                invalid.title = 'Oops!';
                invalid.errMsg = 'Your application is unsuccessful.\n\nPlease reapply.';
                invalid.btnType = btnType.BacktoHome;
                invalid.code = errType;
            }
            else if(errType === Error.Code_M21) { //submit to waa failed
                invalid.title = 'Oops!';
                invalid.errMsg = 'Your submission is unsuccessful.\nTechnical issue.<Code '+errType+'>';
                invalid.btnType = btnType.BacktoHome;
                invalid.code = errType;
            }
            else if(errType === Error.Code_M22) { 
                invalid.title = 'Thank you for your interest.';
                invalid.errMsg = 'Your application is unsuccessful. To apply online, a minimum of S$700,000 turnover is required.\n<Code '+errType+'>';
                invalid.btnType = btnType.BacktoHome;
                invalid.code = errType;
            }
            else if(errType === Error.Code_M23) {
                invalid.title = 'Thank you for your interest.';
                invalid.errMsg = 'Your application is unsuccessful. To apply online, a minimum of S$300,000 turnover is required.\n<Code '+errType+'>';
                invalid.btnType = btnType.BacktoHome;
                invalid.code = errType;
            }
            else if(errType === Error.Code_M26) {
                invalid.title = 'Thank you for your interest.';
                invalid.errMsg = 'We are unable to process your request. The financing requirement is not met.\n<Code '+errType+'>';
                invalid.btnType = btnType.BacktoHome;
                invalid.code = errType;
            }
            else if(errType === Error.Code_M29){ //blze red
                invalid.title = 'Thank you for your interest.';
                invalid.errMsg = 'Your application is unsuccessful. <Code '+errType+'>';
                invalid.btnType = btnType.BacktoHome;
                invalid.code = errType;
            }
            else {
                invalid.title = 'Oops!';
                invalid.errMsg = 'Your application is unsuccessful.\nTechnical issue.\n\nPlease reapply.';
                invalid.btnType = btnType.BacktoHome;
                invalid.code = 'xxxx';
            }
        }
        else {
            invalid.title = 'Oops!';
            invalid.errMsg = 'Your submission is unsuccessful.\nTechnical issue.\n\nPlease reapply.';
            invalid.btnType = btnType.BacktoHome;
            invalid.code = 'xxxx';
        }
 
        setDisplay(invalid);
    }

    return(
        <FormContainer>
            <div className="row around-xs elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <legend id={'lmsg1'} style={{textAlign:'center',paddingTop:'20px'}}>{display.title}</legend>
                </div>
            </div>
            <div style={{paddingTop: "10px"}}><hr className="yellowPanelLine" /></div>
            <br/>     
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div id={'lmsg2'} style={{textAlign:'center',fontSize:'1.1em',whiteSpace:'pre-line'}}>
                    {display.errMsg}
                    </div>
                </div>
            </div>
         
            
            {(display.code === Error.Code_500 || display.code === Error.Code_M12 || display.code === Error.Code_M15 || display.code === Error.Code_M16 || display.code === Error.Code_M18 || display.code === Error.Code_M21 ||display.code === Error.Code_M29) &&
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div id={'lmsg1'} style={{textAlign:'center'}}>
                    {'For queries, get in touch at'}<br/>
                    {'1800-MAYBANK (1800-629 2265) or (65) 6533 5229 (Overseas)'}
                    </div>
                </div>
            </div> 
            }
            <br/>
            
            {display.btnType === btnType.BacktoHome &&
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div style={{textAlign:'center'}}>
                        <button className="k-button btn btn-success" onClick={handleBacktohomeClick}>{'Back to home'}</button>
                    </div>
                </div>
            </div>  
            }
            {display.btnType === btnType.GetInTouch &&
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ paddingBottom: "20px" }}>
                    <button type={'submit'} className="k-button btn-success" onClick={handleGetInTouchClick}>{'Get in Touch'}</button>
                    <button className="k-button btn-back btn-float-right" onClick={handleCancelClick}>{'Cancel'}</button>
                </div>
            </div>  
            }
            <br/> 
        </FormContainer>
    )
}

export default PreKnockoutFailed;